import { render, staticRenderFns } from "./InventoryBookProduct.vue?vue&type=template&id=dacff00c&"
import script from "./InventoryBookProduct.vue?vue&type=script&lang=js&"
export * from "./InventoryBookProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports